import { Toast } from '@douyinfe/semi-ui';
import useStore from '../../store';
import { useUserStore } from '../../store/user';
import { CacheEnum } from '../../enum/cache';

/**
 * Token 过期处理中间件
 * 负责清除所有登录相关的缓存和状态，并跳转到登录页
 */
export class TokenExpiredMiddleware {
  /**
   * 清除所有登录相关的缓存数据
   */
  private static clearCache() {
    // 清除localStorage中的缓存
    localStorage.removeItem(CacheEnum.token.toUpperCase());
    localStorage.removeItem(CacheEnum.userId.toUpperCase());
    localStorage.removeItem(CacheEnum.userCountry.toUpperCase());

    // 清除sessionStorage中的缓存
    sessionStorage.removeItem(CacheEnum.openRouteList.toUpperCase());
    sessionStorage.removeItem(CacheEnum.tabs.toUpperCase());
    sessionStorage.removeItem(CacheEnum.openMenu.toUpperCase());
    sessionStorage.removeItem(CacheEnum.selectMenu.toUpperCase());
  }

  /**
   * 重置store状态
   */
  private static resetStoreState() {
    // 重置主store状态
    const { setToken, setLoginData } = useStore.getState();
    setToken('');
    setLoginData({ id: undefined, country: undefined });

    // 重置用户store状态
    const { setUserInfo, setMenuList, setSubAccountList } =
      useUserStore.getState();
    setUserInfo(undefined as any);
    setMenuList([]);
    setSubAccountList([]);
  }

  /**
   * 跳转到登录页
   */
  private static redirectToLogin() {
    window.location.href = '/login';
  }

  /**
   * 处理token过期的主要方法
   * @param message 可选的错误消息
   */
  public static handle(message?: string) {
    console.log('Token 过期，执行退出登录流程');

    // 显示提示信息
    Toast.error(message || '登录状态已过期，请重新登录');

    // 清除缓存
    this.clearCache();

    // 重置状态
    this.resetStoreState();

    // 跳转到登录页
    this.redirectToLogin();
  }
}
